export default __webpack_public_path__ + "static/media/kanye9.d79519fb.jpeg";